<template>
  <div>
    <van-nav-bar
      title="公开纪念馆申请"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <van-cell-group>
      <van-field
        v-model="form.remark"
        rows="8"
        autosize
        type="textarea"
        maxlength="150"
        placeholder="请严格填写公开理由，这样我们可以更快帮你处理审核！"
      />
    </van-cell-group>

    <div class="btn-area">
      <van-button @click="onsubmit" class="mybtn" block>申请提交</van-button>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      id: "",
      form: {
        type: "PostMemorialHallApply",
        mid: "",
        remark: "",
      },
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onsubmit() {
      var that = this;
      if (this.form.remark == "") {
        Toast("请填写公开理由！");
        return false;
      }
      this.$store.dispatch(this.form).then((res) => {
        // console.log(res,"zzzzzzzzz");
        Toast(res.Message);
        if (res.IsSuccess) {
          setTimeout(() => {
            that.$router.go(-1);
          }, 1000);
        }
      });
    },
  },
  created() {
    var that = this;
    that.id = this.$route.query.id;
    Object.assign(this.form, {
      mid: this.id
    });
  },
};
</script>

<style scoped></style>
